export class GetStudentGUIDApplicantTypeIDRequest {
    StudentID: string;
    AcademicYearID: number;
}